import React from "react";
import CrrButton from "../../../components/UI/CrrButton/CrrButton";

const NavigationButtons = ({ step, sections, handleTraverse }) => {
  return (
    <div className="button-container">
      {step > 1 ? (
        <CrrButton
          className="pre-assessment-secondary-btn"
          onClick={() => handleTraverse(-1)}
          type="secondary"
        >
          BACK
        </CrrButton>
      ) : (
        ""
      )}

      <CrrButton className="pre-assessment-btn btn" htmlType="submit">
        {step < sections.length ? "NEXT" : "SUBMIT"}
      </CrrButton>
    </div>
  );
};

export default NavigationButtons;
